<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 72 72"
    :color="color"
    title="Logo WhatsApp"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72ZM26.4013 20.6997C34.9278 15.5247 45.9225 17.9997 51.3077 26.3248C56.4685 34.8749 54.0003 45.8999 45.6982 51.3C42.7812 53.1 39.4155 54 36.0497 54C32.9084 54 29.7671 53.1 26.8501 51.525L26.1769 51.075L19.4455 52.875L21.2406 46.1249L20.7918 45.4499C15.4066 37.1249 18.0992 25.8748 26.4013 20.6997ZM43.0056 46.1249C44.5762 45.8999 45.6982 44.9999 46.5957 43.6499C47.0444 42.9749 47.0444 42.0749 46.8201 41.3999C46.5957 41.1749 46.1469 40.9499 45.6982 40.7249L42.108 38.9249C41.6593 38.6999 41.4349 38.6999 40.9861 39.1499C40.5374 39.5999 39.4155 40.7249 39.1911 41.1749C38.9667 41.6249 38.5179 41.6249 38.0692 41.3999C36.4985 40.7249 35.1522 39.8249 33.8059 38.6999C32.684 37.5749 31.5621 36.2249 30.6646 34.8749C30.4402 34.4249 30.6646 33.9748 31.1133 33.7498C31.2255 33.6373 31.3377 33.4686 31.4499 33.2998C31.5621 33.1311 31.6743 32.9623 31.7865 32.8498C32.0109 32.6248 32.2353 32.1748 32.0109 31.7248C32.2353 31.4998 32.2353 31.0498 32.0109 30.8248C32.0109 30.6504 31.3366 28.9885 30.8244 27.7261C30.6759 27.3601 30.5411 27.0276 30.4402 26.7748C30.2158 25.8748 29.7671 25.8748 29.3183 25.8748H28.1964C27.7476 25.8748 27.2989 26.0998 26.8501 26.5498C25.7282 27.6748 25.055 29.2498 25.055 31.0498C25.2794 33.0748 25.9526 35.0999 27.2989 36.6749C29.5427 40.0499 32.684 42.9749 36.4985 44.7749C40.3205 46.3079 41.7012 46.2089 42.5811 46.1458C42.7344 46.1348 42.8724 46.1249 43.0056 46.1249Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
